import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles, X } from "lucide-react";

const REASON_COPY = {
  scroll: "You've explored a lot — keep going with a free account.",
  time: "Enjoying RiskPedia? A free account unlocks everything.",
  detail: "Full term breakdowns are free — just sign in to continue.",
};

export default function PaywallModal({ reason, onDismiss, allowDismiss = true }) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center"
      data-testid="paywall-modal"
    >
      {/* Backdrop blur over the page */}
      <div className="absolute inset-0 bg-rp-bg/85 backdrop-blur-md" />
      <div className="relative w-full sm:max-w-md mx-3 sm:mx-0 mb-4 sm:mb-0 rounded-2xl border border-rp-border bg-rp-surface p-7 shadow-[0_20px_60px_rgba(0,0,0,0.6)]">
        {allowDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            data-testid="paywall-dismiss"
            className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full text-rp-textFaint hover:text-rp-text hover:bg-rp-surface2 transition-colors"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        )}
        <div className="flex items-center gap-2 text-rp-accent">
          <Lock className="h-4 w-4" />
          <span className="rp-overline">Free account required</span>
        </div>
        <h2 className="mt-2 font-display text-2xl font-bold tracking-tight">
          Unlock the full encyclopedia
        </h2>
        <p className="mt-2 text-sm text-rp-textDim">
          {REASON_COPY[reason] || REASON_COPY.scroll}
        </p>
        <ul className="mt-5 space-y-2 text-sm text-rp-text">
          <li className="flex items-start gap-2">
            <Sparkles className="mt-0.5 h-4 w-4 text-rp-accent shrink-0" />
            AI Framework Finder — get 4 matched frameworks for your industry.
          </li>
          <li className="flex items-start gap-2">
            <Sparkles className="mt-0.5 h-4 w-4 text-rp-accent shrink-0" />
            1000+ glossary terms with detailed definitions + examples.
          </li>
          <li className="flex items-start gap-2">
            <Sparkles className="mt-0.5 h-4 w-4 text-rp-accent shrink-0" />
            Save assessments, share via public link, export PDF.
          </li>
        </ul>
        <div className="mt-6 flex flex-col sm:flex-row gap-2">
          <Link to="/signup" className="flex-1" data-testid="paywall-signup">
            <Button className="w-full bg-rp-accent hover:bg-rp-accentHover text-white">
              Create free account
            </Button>
          </Link>
          <Link to="/login" className="flex-1" data-testid="paywall-login">
            <Button
              variant="outline"
              className="w-full border-rp-border bg-transparent hover:bg-rp-surface2 text-rp-text"
            >
              Log in
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
